// extracted by mini-css-extract-plugin
export default {"Box":"loading-box-module__Box--ueQKx"};